<template>
  <div class="main">
    <mt-header :title="$t('发现')" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="dl_line"></div>
    <div class="container">
      <div class="dl_line_bottom">
        <h4 class="cateTitle dl_font1_color">{{category.cate_name}}</h4>
        <div class="dappItem" v-for="(item, index) in recommend" :key="index">
          <a @click="myAlert(item,$event)">
            <div class="media">
              <div class="media-bottom">
                <img :src="item.coin_icon" class="media-logo">
              </div>
              <div class="media-body">
                <h5 class="media-heading wx_one_ellipsis dl_font1_color">{{item.name}}</h5>
                <span class="wx_one_ellipsis dl_font12 media-desc dl_font1_color">{{item.intro}}</span>
              </div>
              <img class="back" src="@/assets/img/coinDetail/ico_gengduo.png">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sort from "@/components/Sort";
import { Toast ,MessageBox} from "mint-ui";
import { httpGetFaxianByType } from "@/api/faxian";
import banner1 from "@/assets/img/banner_yaoqinghaoyou.png";
export default {
  name: "TypeList",
  components: { Toast, Sort,MessageBox },
  data() {
    return {
      category:{},
      recommend: [],
    };
  },
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    getData: function(id) {
      httpGetFaxianByType({category_id:id})
        .then(res => {
          this.recommend = res.data.list;
          this.category = res.data.category;
        })
        .catch(() => {});
    },
    myAlert:function(item,event){
      MessageBox({
        title:this.$t('HMC Wallet Pro 声明'),
        message: this.$t('您即将进入第三方Dapp')+'：<br>'+'<span class="dl_main_color">"'+item.name+'"</span>'+'<br>'+this.$t('请务必留意该Dapp的相关用户协议和隐私政策，保护您的资产安全。您在这一Dapp中的所有行为和使用情况，均由该Dapp的供应商负责。'),
        showCancelButton:true
      }).then((action)=>{
        if(action == 'confirm'){
          window.location.href=item.addr
        }
      })
    }
  },
  activated: function() {
    this.category = {}
    this.recommend = []
    this.getData(this.$route.query.type);
  }
};
</script>

<style scoped>
.main {
  padding-top: 40px;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  height: 140px;
}
.swiper img {
  width: 100%;
  max-height: 100%;
  border-radius: 10px;
}
.cateTitle {
  margin: 10px;
}
.dappItem {
  color: #233240;
  opacity: 0.9;
  text-decoration: none;
  background-color: transparent;
  height: 60px;
  position: relative;
}

.media {
  overflow: hidden;
}

.media-logo {
  border-radius: 5px;
  width: 50px;
  vertical-align: middle;
  border-style: none;
  height: auto;
  margin: 5px;
}
.media-body {
  margin-left: 70px;
}
.media-bottom {
  float: left;
}
.media-heading {
  line-height: 30px;
}
.media-desc {
  line-height: 30px;
}
.back {
  height: 15px;
  position: absolute;
  right: 5px;
  top: 20px;
}
.all {
  float: right;
  font-size: 12px;
}
</style>

